import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  createMuiTheme,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  deletePais,
  getPaisById,
  postPais,
  updatePais,
} from "../../../../api/pais";
import Select from "react-select";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { checkIsEmpty } from "../../../../utils/helpers";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyPais() {
  return {
    name: "",
    localName: "",
    active: true,
    prefix: "",
    code: "",
  };
}

export default function EditPaisesPage() {
  const [pais, setPais] = useState(getEmptyPais());
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const paisId = useParams().id;
  const history = useHistory();

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    if (!paisId) {
      disableLoadingData();
      return;
    }
    getPaisById(paisId)
      .then((res) => {
        if (res.status === 200) {
          setPais(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se ha podido obtener la pais.",
        });
        history.push("/paises");
      });
  }, [paisId, disableLoadingData, history]);

  function savePais() {
    if (checkIsEmpty(pais.name))
      return alertError({
        error: null,
        customMessage: "El nombre es requerido.",
      });
    if (!paisId) {
      postPais(pais)
        .then((res) => {
          if (res.status === 201) {
            alertSuccess({
              title: "¡Guardado!",
              customMessage: "Pais creada correctamente.",
            });
            history.push("/paises");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se ha podido guarda la pais.",
          });
        });
    } else {
      updatePais(paisId, pais)
        .then((res) => {
          if (res.status === 200) {
            alertSuccess({
              title: "¡Guardado!",
              customMessage: "Los cambios se han guardado correctamente.",
            });
            history.push("/paises");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se han podido guardar los cambios.",
          });
        });
    }
  }
  const handleChange = (element) => (event) => {
    setPais({ ...pais, [element]: event.target.value });
  };

  const renderStickyButtons = ({
    onBack,
    onSave,
    onDelete,
    setObj,
    obj,
    showDelete = false,
  }) => {
    return (
      <div
        className="sticky-top bg-white border-top shadow-sm"
        style={{
          zIndex: 1000,
          paddingLeft: "15px",
          paddingRight: "15px",
        }}
      >
        <div className="container-fluid">
          <div className="row py-3">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                {/* Botón Back */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onBack}
                    variant="outlined"
                    size="medium"
                    className="text-nowrap"
                    startIcon={<ArrowBackIcon />}
                  >
                    Back
                  </Button>
                </div>

                {/* Botones Save y Delete */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onSave}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: "20px" }}
                  >
                    Save
                  </Button>

                  {showDelete && (
                    <MuiThemeProvider theme={theme}>
                      <Button
                        onClick={onDelete}
                        variant="outlined"
                        color="secondary"
                        size="medium"
                        className="text-nowrap"
                      >
                        Delete
                      </Button>
                    </MuiThemeProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          {renderStickyButtons({
            onBack: () => history.push("/paises"),
            onSave: savePais,
            onDelete: () => setOpenConfirmDialog(true),
            showDelete: !!paisId,
            setObj: savePais,
            obj: pais,
          })}
          <CardHeader title="Editar pais"></CardHeader>
          <CardBody>
            <TextField
              id={`name`}
              label="Nombre internacional"
              value={pais.name}
              onChange={handleChange("name")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
            <TextField
              id={`localName`}
              label="Nombre local"
              value={pais.localName}
              onChange={handleChange("localName")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
            <TextField
              id={`prefix`}
              label="Prefijo"
              value={pais.prefix}
              onChange={handleChange("prefix")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
            <TextField
              id={`code`}
              label="Código ISO"
              value={pais.code}
              onChange={handleChange("code")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />

            {/* Checkboxes */}
            <div style={{ marginTop: "20px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={pais.active || false}
                    onChange={() =>
                      setPais({ ...pais, active: !pais.active })
                    }
                    name="checkActive"
                  />
                }
                label="Active"
              />
            </div>
          </CardBody>
        </Card>
        <div style={{ display: "flex", flexDirection: "row" }}>
          {paisId && (
            <>
              <ConfirmDialog
                title={"¿Estás seguro de que quieres eliminar esta pais?"}
                open={openConfirmDialog}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                  deletePais(paisId)
                    .then((res) => {
                      if (res.status === 204 || res.status === 200) {
                        alertSuccess({
                          title: "¡Eliminada!",
                          customMessage: "Pais eliminada correctamente",
                        });
                        history.push("/paises");
                      }
                    })
                    .catch((error) => {
                      alertError({
                        error: error,
                        customMessage: "No se ha podido eliminar la pais.",
                      });
                    });
                }}
              />
            </>
          )}
        </div>
      </>
    );
}
